import { render, staticRenderFns } from "./superLinks.vue?vue&type=template&id=71ab1b44&scoped=true&"
import script from "./superLinks.vue?vue&type=script&lang=js&"
export * from "./superLinks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71ab1b44",
  null
  
)

export default component.exports